import React from "react";
import { Modal } from "react-bootstrap";
import styles from "../forms/CommunicationForm.module.css"; // adjust path if needed

export default function AttachmentErrorModal({ show, onClose, message }) {
  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton className={styles.modalHeader}>
        <Modal.Title>Attachment Error</Modal.Title>
      </Modal.Header>
      <Modal.Body className={styles.modalBodyDark}>
        <p style={{ whiteSpace: "pre-wrap" }}>{message}</p>
      </Modal.Body>
    </Modal>
  );
}